var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditMagazzino',{attrs:{"id":_vm.id,"duplicateId":_vm.duplicateId}})
}
var staticRenderFns = []

export { render, staticRenderFns }